import script from "./UpgradeRowBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeRowBadge.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeRowBadge.vue?vue&type=style&index=0&id=8d7d03a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d7d03a6"]])

export default __exports__